<template>
    <div class="padding-top upReminder">
        <div class="titleHeaderImage">
            <img src="http://oasisedu.oss-cn-beijing.aliyuncs.com/upload%2Fimage%2F20181122%2F1542875550341019.jpg" alt="">
        </div>
        <div class="content" style="float: left;">
            <div style="width: 8pc;display: table-cell;  vertical-align: middle;   padding-left: 30px;">
                <img :src="syImg" alt="">
                <div style="padding-top: 9pt;text-align: center; font-size: 18px; color: #f70;">
                    {{syName}}
                </div>
            </div>
            <div style="font-size:1pc;display: table-cell;padding-left: 30px;padding-right: 20px;line-height: 2; text-align: justify; vertical-align: middle; position: relative;">
                {{syContent}}
            </div>
            <div class="reminder" style="padding-left: 30px;margin-top: 40px;" v-if="$route.query.name===4||$route.query.name==='4'">
                <div class="redFont">
                    使用次数：建议每月进行一次
                </div>
            </div>
            <div class="reminder" style="padding-left: 30px;margin-top: 40px;" v-else>
                <div style="margin-left:0;font-weight: bold;">注意事项:</div>
                <div>1.对于题目内容列举的若干描述，请选择符合您真实情况的选项</div>
                <div>2.回答请依据你的日常实际表现，而不是你或者别人期望的表现</div>
                <div>3.对于难以选择的题目，不要过多思考，只需凭第一感觉选择</div>
                <div>4.尽量避免受环境或者他人观点的影响</div>
                <div class="redFont">5.测试旨在探索考生的能力特征，请家长不要代为做答</div>
                <div class="redFont">6.为确保测试结果的有效性与科学性，每位考生每6个月只允许测试一次</div>
            </div>
            <div class="upreminderButton">
                <el-button type="primary" @click="searchJL('tt')" v-show="sfShowLsCp">查看历史报告</el-button>
                <el-button type="primary" @click="startAquestion" v-if="$route.query.name==='4'||$route.query.name===4">开始测评</el-button>
                <el-button type="primary" @click="startAquestion" v-else>开始测评剩余次数{{getLimit}}次</el-button>
            </div>
        </div>
        <el-dialog
                title="历史测试报告"
                :visible.sync="dialogVisible"
                width="500px">
            <el-table :data="tableData" height="500px" style="width: 100%">
                <el-table-column label="开始时间" width="180">
                    <template slot-scope="scope">
                        {{ scope.row.start_at | formatDate}}
                    </template>
                </el-table-column>
                <el-table-column prop="result" label="测评结果" width="180">
                </el-table-column>
                <el-table-column v-if="false" prop="start_at" width="180">
                </el-table-column>
                <el-table-column prop="id" label="操作">
                    <template slot-scope="scope">
                        <el-button @click="handleClick(scope.row.id)" type="text" size="small">查看详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="dialogVisible = false">关 闭</el-button>
  </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        FrequencyLimit,
        syTestlistResult
    } from "../../../config";

    export default {
        name: "CareerassessmentUpReminder",
        data() {
            return {
                //获取当前测评类型的剩余次数
                getLimit:null,
                dialogVisible:false,
                tableData: [],
                //是否历史测评记录
                sfShowLsCp: false,
                intoDQContent: [],
                //接收父级路由所传的id
                id: null,
                //获取图片
                syImg: '',
                syContent: '',
                syName: '',
                sixEvaluation: [
                    {
                        id: 1,
                        name: '专业倾向测评',
                        describe: '该系统是高招教育网 专家团队在研究国际知名测试的基础上，结合中国学生特点，以心理测量学为依据，倾力研发的一套旨在帮助学生全面认识自己、科学选择专业、准确定位职业发展方向的专业测评和选择的工具，帮助学生选择专业与定位职业。这一系统由兴趣测评和个人倾向两部分组成，完成测评后，根据您的实际作答情况，系统将整合出一份针对您个人的、具有指导意义的分析报告。同时，根据您的兴趣、喜好等个人优势，结合国家教育部最新公布的国内普通高等院校专业目录，提供六个匹配度较高的专业，并且列出详细的专业信息以及在高等院校的开设情况。',
                        img: 'https://lvzhoustatic.oss-cn-beijing.aliyuncs.com/test/%E4%BA%BA%E6%A0%BC%E7%B1%BB%E5%9E%8B%E6%B5%8B%E8%AF%95.png'
                    },
                    {
                        id: 2,
                        name: '职业性格测试',
                        describe: '职业性格测评系统是高招教育网专家团队基于对拥有长达70多年实践以及广泛职业常模数据的国际知名测试的深入研究，结合中国学生心理特征及中国职业数据，倾力研发的一种迫选型、自我报告式的性格评估理论模型，用以揭示和描述人们在获取信息、作出决策、对待生活等方面的心理活动规律和性格类型。\n' +
                            '\n' +
                            '完成测评后，根据您的实际作答情况，系统将整合出一份具有针对性、指导性的个人专属分析报告。这份报告可以引导你进行全面的自我认知，了解自己自身思维和决策的偏好，帮助你在前程规划时作出更理性的选择。',
                        img: 'https://lvzhoustatic.oss-cn-beijing.aliyuncs.com/test/%E9%9C%8D%E5%85%B0%E5%BE%B7%E6%B5%8B%E8%AF%95%28SOS%29.png'
                    },
                    {
                        id: 6,
                        name: '多元智能测试',
                        describe: '多元智能理论是以多维度的、全面的、发展的眼光来评价学生。每一个学生都有他潜在的智能。智能理论的实施有助于学生发掘自己的"学习风格"，通过多元智能测评，让学生增进自我了解，激发学生学习的积极主动性和学习兴趣。完成测评后，根据您的实际作答情况，系统将整合出一份具有针对性、指导性的个人专属分析报告。这份报告可以引导你进行全面的自我认知，了解自己思维和决策的偏好，帮助你在前程规划时做出更理性的选择。',
                        img: 'http://oasisedu.oss-cn-beijing.aliyuncs.com/upload%2Fimage%2F20181128%2F1543391118293171.jpg'
                    },
                    {
                        id: 3,
                        name: '气质类型测评',
                        describe: '气质类型测评系统是帮助学生认知自我心理特征的有效工具，高招教育网专家团队，结合多年高考志愿指导和考生心理辅导的实践经验，对底蕴深厚的性格类型学说进行深入研究，并参考中国学生性格特征，倾力研发了这套旨在帮助学生全面认知自我、了解自身性格特点的评估系统。完成测评后，根据您的实际作答情况，系统将整合出一份具有针对性、指导性的个人专属分析报告。这份报告可以引导你进行全面的自我认知，了解自己思维和决策的偏好，帮助你在前程规划时做出更理性的选择。',
                        img: 'http://oasisedu.oss-cn-beijing.aliyuncs.com/upload%2Fimage%2F20181128%2F1543390970187520.jpg'
                    },
                    {
                        id: 4,
                        name: '学习压力测试',
                        describe: '压力既可以是你学习的助手也可以变成学习的阻碍。适度的压力有助于提高学习和工作效率，但过度的压力会危害人的健康，中学生在学习生活中所承受的压力适当与否可以通过学习压力测试进行了解判断。',
                        img: 'http://oasisedu.oss-cn-beijing.aliyuncs.com/upload%2Fimage%2F20181128%2F1543392554652984.jpg'
                    },
                    {
                        id: 5,
                        name: '文理兴趣测试',
                        describe: '文理兴趣选择是高中生活的一次重大选择，是今后人生道路的分水岭。合理的选择文理，会激发学生的学习动力，促进学生成绩的提高，而选择不当，则可能会严重的影响学生发挥出真正的学习水平，会阻碍他们兴趣的发展，更有甚者，会产生抵触情绪甚至厌学。不仅如此，文理分科还将影响大学专业选择，专业选择又与未来的职业有着紧密的联系。所以，文理分科选择在很大程度上决定了以后的职业领域，决定了人生职业的方向。某位跨国HR曾经说过，选择比努力更重要！高招教育网文理分科测评系统是高招教育网自主研发的数据分析，通过对用户的行为研究和心理分析，综合评价用户在文科与理科上的竞争力和个人兴趣爱好倾向，帮助用户决策选择文科还是选择理科，竞争优势更大，明确自身对未来具体专业的认知和选择。',
                        img: 'http://oasisedu.oss-cn-beijing.aliyuncs.com/upload%2Fimage%2F20181128%2F1543391055188619.jpg'
                    }
                ]
            }
        },
        filters: {
            formatDate(time) {
                let newDate = new Date(parseInt(time) * 1000);
                const year = newDate.getFullYear();
                const month = newDate.getMonth();
                const day = newDate.getDay();
                const h = newDate.getHours();
                const m = newDate.getMinutes();
                const s = newDate.getSeconds();
                return year+'-'+month+'-'+day+' '+h+':'+m+':'+s;
            }
        },
        beforeDestroy(){
            this.dialogVisible=false;
        },
        mounted() {
            let timer = setTimeout(() => {
                this.getFatherRouterPath();
                this.searchJL();
                this.searchLimit();
                clearTimeout(timer);
            }, 100)
        },
        methods: {
            //查询当前用户测评次数
            async searchLimit(){
                let result=await FrequencyLimit(Number(this.$route.query.name));
                if(result.status){
                    this.getLimit=result.data.surplus_times;
                    if(this.getLimit<1){
                        this.getLimit=0;
                    }

                }else{
                    this.$message({
                        message:result.msg,
                        type:'warning'
                    })
                }
            },
            handleClick(val) {
                this.$router.push({
                    path: '/teacherCenterDashboard/' + 'careerplanningDashboard/careerassessmentUp/' +
                        'careertestreport',
                    query: {
                        id:this.$route.query.name,
                        historyId: val
                    }
                })
            },
            //查询当前id是否有对应记录
            async searchJL(t) {
                let result = await syTestlistResult(Number(this.$route.query.name));
                if (result.status) {
                    this.sfShowLsCp = true;
                    if (t) {
                        this.tableData = result.data;
                        this.dialogVisible=true;
                    }
                }
            },
            startAquestion() {
                if(this.$route.query.name==='4'||this.$route.query.name===4){
                    this.$router.push({
                        path: '/teacherCenterDashboard/careerplanningDashboard/careerassessmentUp/' +
                            'personality_type_test',
                        query: {
                            name: this.id,
                            titleName: this.syName
                        }
                    })
                }else{
                    if(this.getLimit<1||this.getLimit===0){
                        this.$alert('您的评测次数已用完', '温馨提示', {
                            confirmButtonText: '确定',
                        });
                    }else{
                        this.$router.push({
                            path: '/teacherCenterDashboard/careerplanningDashboard/careerassessmentUp/' +
                                'personality_type_test',
                            query: {
                                name: this.id,
                                titleName: this.syName
                            }
                        })
                    }
                }

            },
            //获取生涯测评总路由传过来的值
            getFatherRouterPath() {

                let zhi = this.sixEvaluation.filter((val) => {
                    // console.log(val);
                    //判断导航所显示的值
                    return Number(this.$route.query.name) === val.id;
                });
                // console.log('我是进入当前页后所传入的值');
                // console.log(zhi);
                this.syImg = zhi[0].img;
                this.syContent = zhi[0].describe;
                this.syName = zhi[0].name;
                this.id = this.$route.query.name;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .titleHeaderImage {
        img {
            width: 100%;
            height: auto;
        }
    }

    .upReminder {
        background: #ffffff;
        width: 100%;
        margin: 0 auto;

        padding-left: 60px;
        padding-right: 60px;
        padding-bottom: 40px;
        text-align: left;
        font-size: 14px;
        color: rgb(102, 102, 102);
        list-style: inside;
        height: 100%;
    }

    .upReminder>.content {
        img {
            width: 200px;
            vertical-align: middle;
        }

        .reminder {
            >div {
                margin-left: 10px;
            }

            .redFont {
                color: red;
            }
        }
    }

    .upReminder>.content div {
        list-style: unset;
        margin-bottom: 5px;
    }

    .upReminder>.content li {
        margin-bottom: 5px;
    }

    .upReminder>div:nth-of-type(1) {

        text-align: center;
        line-height: 74px;
        font-size: 24px;
        border-bottom: 1px solid #b8b8b8;
        margin-bottom: 30px;
    }

    .upReminder .upreminderButton {
        margin-top: 20px;
        margin-right: 80px;
        padding-bottom: 80px;
        text-align: right;

    }

    .upReminder .content {
        border-bottom: solid 1px #b8b8b8;
        margin-bottom: 40px;
    }
</style>
